import { useSectionMetaData } from '@v4/components/common/SectionItem'
import { BANNER_VARIANTS } from '@v4/components/sections/Sections.const'
import useStyles from './Banner.styled'

export const useBanner = ({ variant = BANNER_VARIANTS.VARIANT_1, Element }) => {
	const metaData = useSectionMetaData()
	const { classes, cx } = useStyles(metaData)

	return [
		{
			metaData,
			classes,
			cx,
			Element,
			variant,
		},
	]
}
